// Mutation names of the operations to create an account
export const ACCOUNT_CREATION_OPERATIONS = {
  ONBOARD_GUEST: 'OnboardGuestMutation',
  SIGN_UP_NEW_MEMBER: 'SignUpNewMemberMutation',
};

// Map of account creation operation names to the access token type
export const OPERATION_TO_ACCESS_TOKEN_MAP = {
  OnboardGuestMutation: 'guest',
  SignUpNewMemberMutation: 'signup',
};
